import JournalIllustration from './illustrations/JournalIllustration';
import AnalyticsIllustration from './illustrations/AnalyticsIllustration';
import CommunityIllustration from './illustrations/CommunityIllustration';

const FEATURES = [
  {
    id: 'bitacora',
    reversed: false,
    tag: 'Bitácora de trades',
    title: 'Control total de acciones y opciones',
    description:
      'Registra cada compra y venta con fecha, precio, tamaño y notas. Filtra por ticker, estrategia o cuenta. Exporta reportes para impuestos y revisa tu historial completo en segundos.',
    illustration: JournalIllustration,
  },
  {
    id: 'analitica',
    reversed: true,
    tag: 'Analítica avanzada',
    title: 'Descubre qué estrategias te dan más',
    description:
      'Gráficas de rendimiento por fecha, win rate por setup y comparativas entre estrategias. Identifica patrones rentables y ajusta tu plan con datos reales, no con intuición.',
    illustration: AnalyticsIllustration,
  },
  {
    id: 'comunidad',
    reversed: false,
    tag: 'Red social opcional',
    title: 'Comparte solo si quieres',
    description:
      'Tu bitácora es privada por defecto. Publica movimientos, ideas o resultados con tu comunidad cuando lo decidas. Sigue a otros traders y aprende sin exponer lo que prefieras mantener en secreto.',
    illustration: CommunityIllustration,
  },
];

function FeatureSection() {
  return (
    <>
      <section className="intro" aria-labelledby="intro-title">
        <div className="intro__inner">
          <h2 id="intro-title" className="intro__title">
            Con una bitácora clara y analítica en tiempo real, puedes operar con disciplina,
            medir cada decisión y mejorar trade a trade, estés donde estés.
          </h2>
        </div>
      </section>

      {FEATURES.map((feature) => {
        const Illustration = feature.illustration;
        return (
          <section
            key={feature.id}
            id={feature.id}
            className={`feature ${feature.reversed ? 'feature--reversed' : ''}`}
            aria-labelledby={`${feature.id}-title`}
          >
            <div className="feature__inner">
              <div className="feature__text">
                <span className="feature__tag">{feature.tag}</span>
                <h2 id={`${feature.id}-title`} className="feature__title">
                  {feature.title}
                </h2>
                <p className="feature__description">{feature.description}</p>
              </div>
              <div className="feature__visual">
                <Illustration />
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
}

export default FeatureSection;
